import type { Contest } from "~/domains/contest/domains/services/interfaces/contest.interface";
import type { FullContest } from "~/domains/contest/domains/services/interfaces/full-contest.interface";

function getIsContestSingleSlate(contest: FullContest | Contest) {
  return (contest as FullContest)?.slates?.length === 1;
}

export default getIsContestSingleSlate;
